/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckEmailForAuthenticationRequest } from '../../models/check-email-for-authentication-request';
import { CheckEmailForAuthenticationResult } from '../../models/check-email-for-authentication-result';

export interface PostCheckEmail$Params {
  /**
   * The request containing the email address to check.
   */
  body?: CheckEmailForAuthenticationRequest;
}

export function postCheckEmail(
  http: HttpClient,
  rootUrl: string,
  params?: PostCheckEmail$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<CheckEmailForAuthenticationResult>> {
  const rb = new RequestBuilder(rootUrl, postCheckEmail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CheckEmailForAuthenticationResult>;
    }),
  );
}

postCheckEmail.PATH = '/Authentication/check-email';
